var _rect, _rect2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#0D0D0F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "white",
    strokeOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.1621 11.2107C25.3668 11.2107 25.569 11.2226 25.7676 11.2458C26.1111 11.2861 26.3218 11.5286 26.3916 11.8064C26.4595 12.0768 26.4001 12.3919 26.2139 12.6365C25.6789 13.3391 25.374 14.2095 25.374 15.1257L25.375 17.7468C25.3751 20.4227 27.1096 22.3514 28.1641 23.3269C28.7649 23.8827 29.3916 24.3532 29.9395 24.7244C30.1688 24.8798 30.3115 25.1392 30.3115 25.4207V33.6404C30.3113 36.4841 28.0059 38.7898 25.1621 38.7898H17.7568C14.9131 38.7898 12.6076 36.4841 12.6074 33.6404V16.3601C12.6074 13.5162 14.9129 11.2107 17.7568 11.2107H25.1621ZM20.2256 32.6179C19.6611 32.6179 19.2031 33.0759 19.2031 33.6404C19.2033 34.2047 19.6612 34.6619 20.2256 34.6619H22.6934C23.2578 34.6619 23.7156 34.2047 23.7158 33.6404C23.7158 33.0759 23.2579 32.6179 22.6934 32.6179H20.2256ZM31.625 12.0066C32.1626 10.9452 33.7095 10.9451 34.2471 12.0066L35.3359 14.1589L37.7764 14.5056C38.9706 14.6748 39.4628 16.1175 38.5859 16.9509L36.8242 18.6248L37.2402 20.988C37.448 22.1692 36.1821 23.0446 35.1191 22.4998L32.9355 21.3806L30.7529 22.4998C29.69 23.0446 28.4241 22.1693 28.6318 20.988L29.0469 18.6248L27.2852 16.9509C26.4083 16.1175 26.9015 14.6748 28.0957 14.5056L30.5342 14.1589L31.625 12.0066Z",
    fill: "url(#paint0_linear_136_13624)",
    stroke: "#141C2A",
    strokeWidth: 0.424291
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_136_13624",
    x1: 25.8193,
    y1: 11.4226,
    x2: 25.8193,
    y2: 38.5772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FED7AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C2D12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRated);
export default __webpack_public_path__ + "static/media/rated.c49b64f5099fbe86952f124400d92515.svg";
export { ForwardRef as ReactComponent };